import axios from 'CanExConfig/axios'
import { buffers, eventChannel, END } from 'redux-saga'

const createProject = async (id, data, emitter) => {
  const formData = new FormData()

  formData.append('file', data.url)
  {
    data.name && formData.append('name', data.name)
  }
  {
    data.description && formData.append('description', data.description)
  }

  const response = await axios(`/api/candidate/profiles/${id}/projects`, {
    method: 'POST',
    data: formData,
    onUploadProgress: progressEvent => emitter({ progressEvent }),
  })

  emitter({ response: response.data })
  emitter(END)
}

export const createProjectChannel = (id, data) =>
  eventChannel(emitter => {
    createProject(id, data, emitter)
    return () => {}
  }, buffers.sliding(2))

export const fetchProjects = async id => {
  const response = await axios(`/api/candidate/profiles/${id}/projects`, {
    method: 'GET',
  })

  return response.data.result
}

const updateProject = async (id, data, emitter) => {
  const formData = new FormData()
  // Don't judge, I needed to get this to work
  {
    typeof data.url === 'object' && formData.append('file', data.url)
  }
  {
    data.name && formData.append('name', data.name)
  }
  {
    data.description && formData.append('description', data.description)
  }

  const response = await axios(`/api/candidate/projects/${id}`, {
    method: 'PATCH',
    data: formData,
    onUploadProgress: progressEvent => emitter({ progressEvent }),
  })

  emitter({ response: response.data })
  emitter(END)
}

export const updateProjectChannel = (id, data) =>
  eventChannel(emitter => {
    updateProject(id, data, emitter)
    return () => {}
  }, buffers.sliding(2))

export const deleteProject = async id => {
  const response = await axios(`/api/candidate/projects/${id}`, {
    method: 'DELETE',
  })

  return response.data.result
}
